<template>
    <div class="our-clients" data-aos="fade-up">
      <div class="title-wrapper">
      <div class="title">
        <span v-html="$t('about.ourClientsTitle')"></span>
      </div>
      <div class="indentation"></div>   
    </div>
      <div class="group">
        <div class="row">
          <div class="item" v-for="(client, index) in clients" :key="index" >
           <img loading="lazy" class="client-logo" :src="client.src" :alt="client.alt"/>  
          </div>
        </div>
        <div aria-hidden class="row">
         <div class="item" v-for="(client, index) in clients" :key="index" >
           <img loading="lazy" class="client-logo" :src="client.src" :alt="client.alt"/>  
          </div>
        </div>
    </div>
    </div>
</template>

<script>
import smoothScroll from '../helpers/SmoothScroll';

export default {
  name: 'clients',
  data() {
    return {
      clients: [
        { src: "/static/img/clients/Acciona.png", alt: "Acciona" },
        { src: "/static/img/clients/boralex.png", alt: "Boralex" },
        { src: "/static/img/clients/capital_energy.png", alt: "Capital Energy" },
        { src: "/static/img/clients/Disa.png", alt: "Disa" },
        { src: "/static/img/clients/EDF.png", alt: "EDF" },
        { src: "/static/img/clients/EDPR.png", alt: "EDPR" },
        { src: "/static/img/clients/Elawan.png", alt: "Elawan" },
        { src: "/static/img/clients/enel.png", alt: "enel" },
        { src: "/static/img/clients/ENERGITER_VERT.png", alt: "Energiter ver" },
        { src: "/static/img/clients/Energix_Renewables.png", alt: "Energix renewables" },
        { src: "/static/img/clients/engie.png", alt: "Engie" },
        { src: "/static/img/clients/forestalia.png", alt: "Forestalia" },
        { src: "/static/img/clients/iberdrola.png", alt: "Iberdrola" },
        { src: "/static/img/clients/Iqony.png", alt: "Iqony" },
        { src: "/static/img/clients/luminus_luminus.png", alt: "Luminus" },
        { src: "/static/img/clients/naturgy.png", alt: "Naturgy" },
        { src: "/static/img/clients/PAK_SERWIS.png", alt: "Pak serwis" },
        { src: "/static/img/clients/PNE.png", alt: "PNE" },
        { src: "/static/img/clients/rr.png", alt: "Red Rocket" },
        { src: "/static/img/clients/RWE.png", alt: "RWE" },
        { src: "/static/img/clients/soler.png", alt: "Soler" },
        { src: "/static/img/clients/TotalEnergies.png", alt: "TotalEnergies" },
        { src: "/static/img/clients/WPO.png", alt: "WPO" },
      ]
    };
  },
  watch: {
    lang() {
      this.team = this.$root.$t("team")
    }
  },
  props: [],
  methods: {},
  computed: {
    lang: () => {
      return store.state.lang;
    },
    scrollOffset: () => {
      return window.innerWidth > 980 ? 130 : 90;
    },
    smoothScroll: () => smoothScroll
  }
}
</script>

<style scoped>
@import "https://use.fontawesome.com/releases/v5.7.1/css/all.css";


.our-clients{
  position:fixed;
  bottom: 0;
  z-index: 5;
}
.row {
  display: flex;
  will-change: transform; 
  animation: scrolling 60s linear infinite;
}
.item {
  margin: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.group{
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: white;
}
.title-wrapper{
  position: absolute;
  top: -25px;
  margin-bottom: -1px;
  display: flex;
  align-items: flex-end;
}
.title{
  font-family: "Ubuntu";
  color: #e74011;
  font-weight: bold;
  background-color: white;
  display: inline-block;
  padding: 10px 10px 0 20px;
  margin: 0; 
}
.indentation {
  width: 0;
  height: 0;
  margin: 0; 
  border-left: 0 solid transparent;
  border-right: 50px solid transparent; 
  border-bottom: 26px solid white; 
}

.client-logo{
  max-height: 25px;
  max-width: 300px;
}

@media (max-width: 768px) {
  .client-logo{
    max-height: 30px;
    max-width: 100px;
  }

  .row {
    animation: scrolling 30s linear infinite;
  }
 
  .indentation {
    border-right: 50px solid transparent; 
    border-bottom: 26px solid white; 
    margin-left: -1px;
  }

  .item {
    flex: 1; 
    margin: 15px 10px;
  }
}


@keyframes scrolling {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
  }

</style>



// WEBPACK FOOTER //
// Clients.vue?29871cdc